<template>
    <div>
        <div class="filter-bar">
            <el-form :inline="true" :model="formItem">
                <!--<el-form-item label="" label-width="0">-->
                    <!--<span class="text-bold">项目覆盖</span>-->
                <!--</el-form-item>-->
                <el-form-item label="" label-width="0">
                    <el-date-picker
                        v-model="formItem.range_time"
                        :picker-options="dateOptions"
                        @change="changeRangeTime"
                        :clearable="false"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        size="mini"
                        value-format="yyyy-MM-dd"
                        style="width: 205px;">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="项目名称：" >
                    <BatchMultipleSelect
                        ref="projectBatchSelect"
                        :value="formItem.project"
                        :options="projectOptionList"
                        :loading="projectOptionLoading"
                        :remote-method="(query)=>remoteOptionList(query,'project')"
                        @change="(val)=>changeOptionsSearch(val,'project')"
                        @batch-submit="(con)=>batchQuerySubmit(con,'project')"
                        @clear-all="(val)=>clearBatchSearch(val,'project')"
                        @change-all="(val)=>changeBatchSearchAll(val,'project')"
                        @show-options="showSelectOptions('project')"
                        title="项目名称"
                        :batch-desc="'输入或粘贴项目名称，每行一个'"
                        :clearable="true"
                        :collapse-tags="true"
                        size="mini"
                        :input-width="180"
                        placeholder="输入关键字搜索" />
                </el-form-item>
                <el-form-item label="集团名称：" >
                    <BatchMultipleSelect
                        ref="blocBatchSelect"
                        :value="formItem.bloc"
                        :options="blocOptionList"
                        :loading="blocOptionLoading"
                        :remote-method="(query)=>remoteOptionList(query,'bloc')"
                        @change="(val)=>changeOptionsSearch(val,'bloc')"
                        @batch-submit="(con)=>batchQuerySubmit(con,'bloc')"
                        @clear-all="(val)=>clearBatchSearch(val,'bloc')"
                        @change-all="(val)=>changeBatchSearchAll(val,'bloc')"
                        @show-options="showSelectOptions('bloc')"
                        title="集团名称"
                        :batch-desc="'输入或粘贴集团名称，每行一个'"
                        :clearable="true"
                        :collapse-tags="true"
                        size="mini"
                        :input-width="180"
                        placeholder="输入关键字搜索" />
                </el-form-item>
                <el-form-item label="销售人员：" >
                    <ESelect v-model="formItem.user_ids" :multiple="false" collapse-tags filterable clearable :loading="userLoading" placeholder="下拉选择" size="mini" class="select-tags-width" style="width:100px">
                        <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="项目类型：" >
                    <ESelect v-model="formItem.project_type" @change="changeProjectType" :multiple="true" collapse-tags filterable clearable placeholder="下拉选择" size="mini" class="select-tags-width" style="width:150px">
                        <el-option value="all-option">全选</el-option>
                        <el-option v-for="item in projectTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </ESelect>
                </el-form-item>

                <el-form-item label="" label-width="0">
                    <el-button v-matomo="{behaviorCategory: '销售负责人', event: '点击',  name: '项目覆盖(查询)' }" size="mini" type="primary" :loading="dataLoading" @click="submitSearch">查询</el-button>
                    <el-button v-matomo="{behaviorCategory: '销售负责人', event: '点击',  name: '项目覆盖(导出)' }" size="mini" :loading="exportLoading" @click="exportData">导出</el-button>
                    <!--<el-button size="mini" @click="isMarker=!isMarker">高亮</el-button>-->

                </el-form-item>
            </el-form>

        </div>
        <div class="data-list">
            <el-table
                v-loading="dataLoading"
                :data="dataList"
                stripe
                :border="true"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                :default-sort = "{prop: 'log_time', order: 'descending'}"
                size="mini">
                <el-table-column
                    prop="project_name"
                    label="项目名称"
                    width="150"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.project_name||'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="project_type"
                    label="项目类型"
                    width="200"
                    show-overflow-tooltip>
                             <template slot-scope="scope">
                        <span>{{scope.row.project_type||'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="bloc_name"
                    label="所属集团"
                    width="175"
                    show-overflow-tooltip>
                             <template slot-scope="scope">
                        <span>{{scope.row.bloc_name||'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="xs_names"
                    label="负责销售"
                    min-width="150"
                    show-overflow-tooltip>
                             <template slot-scope="scope">
                        <span>{{scope.row.xs_names||'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="start_date"
                    label="开投日期"
                    width="100"
                    align="center"
                    show-overflow-tooltip>
                             <template slot-scope="scope">
                        <span>{{scope.row.start_date||'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="oppo_status"
                    label="OPPO"
                    min-width="100"
                    align="center"
                    show-overflow-tooltip>
                             <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.oppo_status)">{{scope.row.oppo_status||'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="vivo_status"
                    label="vivo"
                    min-width="100"
                    align="center"
                    show-overflow-tooltip>
                             <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.vivo_status)">{{scope.row.vivo_status||'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="huawei_status"
                    label="华为商店"
                    min-width="100"
                    align="center"
                    show-overflow-tooltip>
                             <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.huawei_status)">{{scope.row.huawei_status||'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="huawei_ads_status"
                    label="华为Ads"
                    min-width="100"
                    align="center"
                    show-overflow-tooltip>
                             <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.huawei_ads_status)">{{scope.row.huawei_ads_status||'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="honor_status"
                    label="荣耀"
                    min-width="100"
                    align="center"
                    show-overflow-tooltip>
                             <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.honor_status)">{{scope.row.honor_status||'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="mi_status"
                    label="小米"
                    min-width="100"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.mi_status)">{{scope.row.mi_status||'-'}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-bar tar">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="queryData.pn"
                    :page-size="10"
                    :pager-count="5"
                    layout="total, prev, pager, next"
                    :total="totalCnt">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import BatchMultipleSelect from '@/components/BatchMultipleSelect';
    import dayjs from 'dayjs';
    import API from '@/api/dashboard.js';

    export default {
        name: "ProjectCover",
        components:{
            BatchMultipleSelect,
        },
        data(){
            let _this = this;
            let yesterdayStr = dayjs().subtract(1,'day').format('YYYY-MM-DD');
            return {
                dataLoading:false,
                exportLoading:false,
                formItem:{
                    project:[],
                    bloc:[],
                    range_time:[yesterdayStr,yesterdayStr],
                    user_ids:'',
                    project_type:[],
                },
                queryData: {
                    pn: 1,
                },
                queryParams:{},     //临时缓存
                totalCnt:0,
                projectOptionList:[],
                projectOptionLoading:false,
                projectTypeList:[
                    {
                        id:'1',
                        name:'应用IAP',
                    },
                    {
                        id:'2',
                        name:'应用IAA',
                    },
                    {
                        id:'3',
                        name:'快应用IAP',
                    },
                    {
                        id:'4',
                        name:'快应用IAA',
                    },
                    {
                        id:'5',
                        name:'小程序IAP',
                    },
                    {
                        id:'6',
                        name:'小程序IAA',
                    },
                    // {
                    //     id:'7',
                    //     name:'IOS应用IAP',
                    // },
                    // {
                    //     id:'8',
                    //     name:'IOS应用IAA',
                    // },
                    {
                        id:'9',
                        name:'包含未分配',
                    },

                ],
                projectOptionsAll:[],

                blocOptionList:[],
                blocOptionLoading:false,
                blocOptionsAll:[],



                dateOptions:{
                    firstDayOfWeek: 1,
                    disabledDate(time){
                        let pickedDate = _this.pickedDate;
                        if(!pickedDate){
                            return time.getTime() > Date.now()-1000*60*60*24;
                        }else{
                            if(time.getTime() > Date.now()-1000*60*60*24) return true;
                            return (time.getTime() > pickedDate.getTime()+1000*60*60*24*366)||(time.getTime() < pickedDate.getTime()-1000*60*60*24*367);
                        }
                    },
                    onPick:({ maxDate, minDate })=>{
                        if(maxDate===null&&!!minDate){
                            _this.pickedDate = minDate
                        }else if(!!maxDate&&!!minDate){
                            // _this.pickedDate = null;
                        }
                    },
                },
                dataList:[],

                pickedDate:null,
                confirmTip:null,
                isMarker:false,
                userList:[],
                userLoading:false,
            }
        },
        mounted(){
            this.getUserList();
        },
        methods:{
            getUserList(){
                this.userLoading = true;
                API.getXSProjectSearchList({
                    search_type:'xs_list',
                }).then(res=>{
                    this.userLoading = false;
                    let resData = res.data||{};
                    this.userList = resData.list||[];
                },err=>{
                    this.userLoading = false;
                    this.userList = [];

                    if (err.code == '403') {
                        if(this.confirmTip) return;
                        this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                            this.confirmTip = null;
                        }).catch(() => {
                            this.confirmTip = null;
                        });
                        return
                    }
                    this.$message.error(err.info||'请求有误');
                })
            },
            remoteOptionList(query,type){
                console.log('remoteOptionList',query,type);

                let allList = this[type+'OptionsAll'];

                if (query !== '') {
                    this[type+'OptionLoading'] = true;
                    API.getXSProjectSearchList({
                        search_type:type+'_name',
                        search:query,
                    }).then(res=>{
                        this[type+'OptionLoading'] = false;
                        let resData = res.data||{};
                        this[type+'OptionList'] = (resData.list||[]).map(item=>{
                            return {
                                value:item[type+'_name'],
                                label:item[type+'_name'],
                            }
                        });

                        allList.forEach(item=>{
                            if(!allList.find(inner=>inner.label==item.label&&inner.value==item.value)){
                                allList.push({...item});
                            }
                        });
                    },err=>{
                        this[type+'OptionLoading'] = false;
                        console.log('getXSProjectSearchList err',err);
                        if (err.code == '403') {
                            if(this.confirmTip) return;
                            this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                                this.confirmTip = null;
                            }).catch(() => {
                                this.confirmTip = null;
                            });
                            return
                        }

                        this[type+'OptionList']  = [];
                    })
                } else {
                    this[type+'OptionList']  = [];
                }
            },
            changeOptionsSearch(val,type){
                console.log('changeOptionsSearch',val,type);
                if(type=='project'){
                    this.formItem.project = [...val];
                }else{
                    this.formItem.bloc = [...val];
                }
            },
            batchQuerySubmit(con,type){
                console.log('changeOptionsSearch',con,type);
                console.log(this.$refs,this.$refs.projectBatchSelect);

                API.getXSProjectSearchList({
                    search_type:type+'_name',
                    batch_search:con,
                }).then(res=>{
                    this.$refs[type+'BatchSelect'].hideBatchLoading();

                    let resData = res.data || {};
                    let successList = resData.list||[];
                    let errList = resData.err_list||[];

                    if(errList.length>0){
                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p>未找到以下内容，请核实，是否需要剔除未找到的内容?</p>';
                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                        this.$confirm(htmlStr, '提示', {
                            confirmButtonText: '剔除',
                            cancelButtonText: '关闭',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            customClass:'batch-err-tips-modal',
                            width:'500',
                        }).then(()=>{
                            this.addBatchList(successList,type);
                            this.$refs[type+'BatchSelect'].hideBatchModal();
                        });
                    }else{
                        this.addBatchList(successList,type);
                        this.$refs[type+'BatchSelect'].hideBatchModal();
                    }
                },err=>{
                    console.log('getXSProjectSearchList batch error', err);
                    this.$refs[type+'BatchSelect'].hideBatchLoading();
                    if (err.code == '403') {
                        if(this.confirmTip) return;
                        this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                            this.confirmTip = null;
                        }).catch(() => {
                            this.confirmTip = null;
                        });
                        return
                    }
                    this.$message.error(err.info||'请求有误');
                })
            },
            clearBatchSearch(val,type){
                console.log('clearBatchSearch',val,type);

                let formValue = this.formItem[type];
                val.forEach(item=>{
                    let index = formValue.findIndex(inner=>inner==item);
                    if(index!=-1){
                        this.formItem[type].splice(index,1);
                    }
                })

            },
            changeBatchSearchAll(val,type){
                console.log('changeBatchSearchAll',val,type);

                let formValue = this.formItem[type];
                let oldVal = formValue;
                let newVal = [...val].filter(item=>!oldVal.includes(item));
                this.formItem[type] = oldVal.concat(newVal);
            },
            showSelectOptions(type){
                console.log('showSelectOptions',type);

                let allOptions = this[type+'OptionsAll'];
                let list = this.formItem[type].map(item=>{
                    let actionItem = allOptions.find(inner=>inner.value==item);
                    return {
                        label:actionItem?actionItem.label:item,
                        value:item,
                    }
                });
                this.$set(this,type+'OptionList',list);
                console.log(4444,type,this[type+'OptionList'] );
            },
            addBatchList(list,type){
                console.log('addBatchList',list,type);

                let optionIdList = this[type+'OptionList'].map(item=>item.value);
                let allList = this[type+'OptionsAll'];
                let formValue = this.formItem[type];

                (list||[]).forEach(item=>{
                    if(!optionIdList.includes(item[type+'_name'])){
                        this[type+'OptionList'].push({
                            value:item[type+'_name'],
                            label:item[type+'_name'],
                        });

                        optionIdList.forEach(item=>{
                            if(!allList.find(inner=>inner.label==item.label&&inner.value==item.value)){
                                allList.push({...item});
                            }
                        });
                    }
                    if(!formValue.includes(item[type+'_name'])){
                        formValue.push(item[type+'_name']);
                    }
                })
            },
            exportData(){
                let params = {
                    project_name:this.formItem.project.join(','),
                    bloc_name:this.formItem.bloc.join(','),
                    user_ids:this.formItem.user_ids,
                    project_type:this.formItem.project_type.join(','),
                    range_time: this.formItem.range_time.join('/'),
                };
                console.log('exportData',params);
                this.exportLoading = true;
                API.getXSProjectList(Object.assign({},params,{
                    pn:1,
                    export:'1',
                })).then(res => {
                    this.exportLoading = false;
                    this.$message.success(res.info||'请求成功');
                }, (err) => {
                    console.log('getXSProjectList error', err);
                    this.exportLoading = false;
                    if (err.code == '403') {
                        if(this.confirmTip) return;
                        this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                            this.confirmTip = null;
                        }).catch(() => {
                            this.confirmTip = null;
                        });
                        return
                    }
                    this.$message.error(err.info||'请求异常');
                });
            },
            getDataList(params){
                this.dataLoading = true;
                this.queryParams = {...params};
                API.getXSProjectList(Object.assign({},params,{
                    pn:this.queryData.pn,
                }),{
                    timeout:120*1000,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    this.dataList = resData.list;
                    this.totalCnt = resData.totalCnt||0;
                }, (err) => {
                    console.log('getXSProjectList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                    if (err.code == '403') {
                        if(this.confirmTip) return;
                        this.confirmTip = this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                            this.confirmTip = null;
                        }).catch(() => {
                            this.confirmTip = null;
                        });
                        return
                    }
                    this.$message.error(err.info||'请求异常');

                });
            },
            submitSearch(){
                console.log('submitSearch');
                let params = {
                    project_name:this.formItem.project.join(','),
                    bloc_name:this.formItem.bloc.join(','),
                    user_ids:this.formItem.user_ids,
                    project_type:this.formItem.project_type.join(','),
                    range_time: this.formItem.range_time.join('/'),
                };
                this.queryData.pn = 1;
                this.getDataList(params);
            },
            changeProjectType(val){
                if(val.includes('all-option')){
                    this.formItem.project_type = this.projectTypeList.map(item=>item.id);
                }else{
                    this.formItem.project_type = val;
                }
            },
            changeRangeTime(val){
                console.log('changeRangeTime',val);
                this.pickedDate = null;
            },
            handleCurrentChange(val) {
                this.queryData.pn= val;
                this.getDataList(this.queryParams);
            },
            getStatusClass(val){
                if(this.isMarker){
                    if(val=='未投放') return 'text-color-error';
                    return '';
                }
                return '';
            }
        }

    }
</script>

<style lang="scss" scoped>
    .filter-bar {
        ::v-deep .el-form-item{
            margin-bottom: 10px;
        }
        ::v-deep .el-form-item__label{
            padding-right: 0;
        }
    }
    .data-list {
        ::v-deep .el-table__cell{
            padding: 3px 0;
        }
    }
</style>
